'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const LoyaltyAppFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#22D3EE"
      ariaLabel={t('LoyaltyApp/FinalCTA/aria_label')}
      copy={{
        headlineA: t('LoyaltyApp/FinalCTA/title1'),
        headlineB: t('LoyaltyApp/FinalCTA/title2'),
        subhead: t('LoyaltyApp/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('LoyaltyApp/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('LoyaltyApp/FinalCTA/cta_secondary'),
          href: `/${lang}/contact-us`,
        },
      }}
    />
  );
};

export default LoyaltyAppFinalCTA;
